import { Predicate } from "@siteimprove/alfa-predicate";
import { Refinement } from "@siteimprove/alfa-refinement";
import { Element } from "../../element.js";
import { hasName } from "./has-name.js";
const { not, or, test } = Predicate;
const { and } = Refinement;
/**
 * Children of <iframe>, <audio>, <video> elements act as fallback content in
 * legacy user agents.
 *
 * <track> and <source> children of audio and video are allowed by the content
 * model of both. Thus, they will be not act as fallback
 *
 * {@link https://html.spec.whatwg.org/multipage/#the-video-element}
 * {@link https://html.spec.whatwg.org/multipage/#the-audio-element}
 *
 * @public
 */
export function isFallback(node) {
    return test(or(hasParentName("iframe"), and(hasParentName("audio", "video"), not(and(Element.isElement, hasName("track", "source"))))), node);
}
function hasParentName(name, ...names) {
    return (node) => node
        .parent()
        .filter(Element.isElement)
        .some(hasName(name, ...names));
}
//# sourceMappingURL=is-fallback.js.map